import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-reject-custom-industry-request',
  templateUrl: './dialog-reject-custom-industry-request.component.html',
  styleUrls: ['./dialog-reject-custom-industry-request.component.scss']
})
export class DialogRejectCustomIndustryRequestComponent {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogRejectCustomIndustryRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { industryDisplayName?: string },
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      comment: ['', Validators.required]
    });
  }

  onSave(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.comment as string);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
